import React from 'react'
import Head from 'next/head'

import { isToggleEnabled } from 'configs/toggle-feature'
import AccountApp from 'app/Homepage/pages/Account'
import { getDeviceId } from 'utils/deviceId'

export async function getServerSideProps(ctx) {
  const isRuangGtkEnabled = await isToggleEnabled('ruang-gtk-enabled')
  return {
    props: {
      appDeviceID: getDeviceId(ctx),
      isRuangGtkEnabled,
    },
  }
}

export const AccountPage = ({ isRuangGtkEnabled = false }) => {
  return (
    <>
      <Head>
        <title>Akun - Ruang GTK</title>
      </Head>
      <AccountApp isRuangGtkEnabled={isRuangGtkEnabled} />
    </>
  )
}

AccountPage.layoutOpts = {
  hasHeader: false,
}

export default AccountPage
